import {
  useTranslate,
  IResourceComponentsProps,
} from "@pankod/refine-core";
import {
  List,
  Table,
  TextField,
  useTable,
  getDefaultSortOrder,
  DateField,
  Space,
  EditButton,
  DeleteButton,
  ShowButton,
} from "@pankod/refine-antd";
import { INews } from "interfaces";

export const NewsList: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();

  const { tableProps, sorter } = useTable<INews>({
    initialSorter: [
      {
        field: "news_id",
        order: "desc",
      },
    ],
  });

  return (
    <List>
      <Table {...tableProps} rowKey="news_id">
        <Table.Column
          dataIndex="news_id"
          key="news_id"
          title="ID"
          render={(value) => <TextField value={value} />}
          defaultSortOrder={getDefaultSortOrder("news_id", sorter)}
          sorter
        />
        <Table.Column
          dataIndex="title"
          key="title"
          title={t("news.fields.title")}
          render={(value) => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="url"
          key="url"
          title={t("news.fields.url")}
          render={(value) => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="description"
          key="description"
          title={t("news.fields.description")}
          render={(value) => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="date"
          key="date"
          title={t("news.fields.date")}
          render={(value) => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="created_at"
          key="created_at"
          title={t("parameter.fields.created_at")}
          render={(value) => <DateField value={value} format="LLL" />}
        />
        <Table.Column<INews>
          title={t("table.actions")}
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton hideText size="small" recordItemId={record.news_id} />
              <ShowButton hideText size="small" recordItemId={record.news_id} />
              <DeleteButton hideText size="small" recordItemId={record.news_id} />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
